import React, { ReactElement, ReactNode } from 'react'

export enum HeadingLevel {
    ONE,
    TWO,
    THREE,
    FOUR,
    FIVE,
    SIX
}

export type HeadingProps = {
    level: HeadingLevel
    children: ReactNode
    className?: string
}

/**
 *
 * @param level h1, h2...
 * @param children
 *
 */
const Heading: React.FC<HeadingProps> = ({ level, children, className }: HeadingProps): ReactElement => {
    const headingElement = (): ReactElement => {
        switch (level) {
            case HeadingLevel.ONE:
                return <h1 className={`heading1 ${className}`}>{children}</h1>
            case HeadingLevel.TWO:
                return <h2 className={`heading2 ${className}`}>{children}</h2>
            case HeadingLevel.THREE:
                return <h3 className={`heading3 ${className}`}>{children}</h3>
            case HeadingLevel.FOUR:
                return <h4 className={`heading4 ${className}`}>{children}</h4>
            case HeadingLevel.FIVE:
                return <h5 className={`heading5 ${className}`}>{children}</h5>
            case HeadingLevel.SIX:
                return <h6 className={`heading6 ${className}`}>{children}</h6>
            default:
                return <h1 className={`heading1 ${className}`}>{children}</h1>
        }
    }

    return headingElement()
}
export default Heading
